import { Laptop } from "lucide-react";
import { Button } from "flowbite-react";
import ItemTable from "./ItemTable";
import { ModalFrom } from "./ModalFrom";
import { useEffect, useState } from "react";
import axiosInstance from "../config/config";

export default function ItemPage() {
  const [openModal, setOpenModal] = useState(false);
  const [items, setItems] = useState([]);
  const [e_id, setEid] = useState(0);

  const fetchItems = async () => {
    try {
      const response = await axiosInstance.post("", {
        SysID: `select * from dbo.job_item;`,
      });
      setItems(response.data || []);
    } catch (error) {
      console.error("Error fetching items:", error);
    }
  };

  useEffect(() => {
    fetchItems();
  }, []);

  const opModal = (id = 0) => {
    setEid(id);
    setOpenModal(true);
  };

  const closeModal = () => {
    setOpenModal(false);
    setEid(0);
  };

  return (
    <div className="h-full bg-slate-700 p-4 sm:p-12 overflow-auto">
      <div className="flex align-center items-center gap-2">
        <Laptop className="text-white" size={35} />
        <h1 className="text-4xl font-bold text-white">Items</h1>
      </div>
      <div className="flex mt-4">
        <Button onClick={() => opModal(0)} className="ml-auto">
          + Add Item
        </Button>
      </div>
      <div className="mt-8">
        <ItemTable items={items} opModal={opModal} />
      </div>
      {openModal && (
        <ModalFrom closeModal={closeModal} e_id={e_id} fetchItems={fetchItems} />
      )}
    </div>
  );
}
